<template>
  <div>
    <comment
      :comment="value"
      @editComment="$emit('editComment', $event)"
      @deleteComment="$emit('deleteComment', $event)"
    />
  </div>
</template>

<script>
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';
import axios from 'axios';

import Comment from '../Comment.vue';

export async function fetchComments({ job: { api_id: jobApiId } }) {
  const queryString = RequestQueryBuilder.create({
    filter: {
      field: `jobApiId`,
      operator: CondOperator.EQUALS,
      value: jobApiId,
    },
  }).query();

  return await axios.get(`/data-api/comment?${queryString}`).then(({ data }) =>
    data.map((value) => ({
      time: new Date(value.createdAt),
      value,
    })),
  );
}

export default {
  components: {
    Comment,
  },
  props: {
    value: Object,
  },
};
</script>
